import { forms } from '../bff.api';
import responseValidators from '../response.validators';

const _handleError = (err, onError) => {
  if (onError) {
    onError(err.message);
  }
};

const getBySlug = async (slug, options = {}) => {
  return forms
    .getBySlug(slug)
    .then((resp) => {
      responseValidators.getFormBySlug(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const formsService = {
  getBySlug
};

export default formsService;
